// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1tkC6","logo":"header_logo__38OIj","back":"header_back__1rtsh"};